<div class="ba-image">
  <div [attr.id]="'person-' + person.id" class="kontakt-person">
    <div class="avatar">
      <now-wbsuche-lib-kontakt-avatar
        class="avatar-svg"
        aria-hidden="true"
      ></now-wbsuche-lib-kontakt-avatar>
    </div>
    <dl>
      <div>
        <dt>Name</dt>
        <dd>
          {{ person.titel }} {{ person.vorname }}
          {{ person.nachname }}
        </dd>
      </div>

      @if (person.rollen?.length! > 0) {
        <div>
          <dt>Funktion</dt>
          <dd>
            @for (rolle of person.rollen; track rolle.id) {
              <span>{{ rolle.bezeichnung }}</span>
            }
          </dd>
        </div>
      }

      @if (person.telefonDurchwahl) {
        <div>
          <dt>Telefon</dt>
          <dd>
            {{ person.telefonVorwahl ? person.telefonVorwahl + ' /' : '' }}
            {{ person.telefonDurchwahl }}
          </dd>
        </div>
      }

      @if (person.mobilDurchwahl) {
        <div>
          <dt>Mobil-Telefon</dt>
          <dd>
            {{ person.mobilVorwahl ? person.mobilVorwahl + ' /' : '' }}
            {{ person.mobilDurchwahl }}
          </dd>
        </div>
      }

      @if (person.email; as email) {
        <div>
          <dt>E-Mail</dt>
          <dd>
            <a
              [nowWbsucheLibFocusableIfVisible]="collapsed"
              [attr.href]="'mailto:' + email"
              class="now-link-secondary now-link-icon now-icon-arrow-square-out py-0"
            >
              {{ email }}</a
            >
          </dd>
        </div>
      }
    </dl>
  </div>
</div>
<div class="ba-caption d-none" aria-hidden="true">
  Kontaktperson {{ person.titel }} {{ person.vorname }} {{ person.nachname }}
</div>
